import React from 'react'

import { Box } from 'components/layout/Box/Box'
import { Table } from 'components/shared/Table/Table'
import type { TableCellProps } from 'components/shared/Table/types'

type ActionsCellProps = Pick<
  TableCellProps,
  'children' | 'className' | 'maxWidth' | 'hasIncreasedHeight'
>

export const ActionsCell = ({
  children,
  className,
  maxWidth,
  hasIncreasedHeight,
}: ActionsCellProps) => (
  <Table.Cell type="body" {...{ className, maxWidth, hasIncreasedHeight }}>
    <Box justify="flex-end" align="center" tagName="span">
      {children}
    </Box>
  </Table.Cell>
)
